const initialState = {
  title: "",
  h1: "",
  description: "",
  content: "",
  yandexTag: "",
  googleTag: "",
  cityName: "",
  cityNameDec: "",
  /** SSR: <link> теги (canonical/prev/next) */
  canonical: [],
  /** SSR: пары property/content для og:* */
  openGraphTags: [],
  /** SSR: строки JSON-LD (Product, AutoPartsStore, BreadcrumbList) */
  jsonLdScripts: [],
  /** SSR: ссылки перелинковки для текущей страницы ({ url, anchor }) */
  internalLinks: [],
};

export const metaReducer = (state = initialState, action) => {
  switch (action.type) {
    case "SET_TITLE":
      return { ...state, title: action.payload };
    case "SET_H1":
      return { ...state, h1: action.payload };
    case "SET_DESCRIPTION":
      return { ...state, description: action.payload };
    case "SET_CONTENT":
      return { ...state, content: action.payload };
    case "SET_Y_TAG":
      return { ...state, yandexTag: action.payload };
    case "SET_G_TAG":
      return { ...state, googleTag: action.payload };
    case "SET_CITY_NAME":
      return { ...state, cityName: action.payload };
    case "SET_CITY_NAME_DEC":
      return { ...state, cityNameDec: action.payload };
    case "SET_META_CANONICAL":
      return { ...state, canonical: action.payload };
    case "SET_META_OPEN_GRAPH_TAGS":
      return { ...state, openGraphTags: action.payload };
    case "SET_META_JSON_LD_SCRIPTS":
      return {
        ...state,
        jsonLdScripts: Array.isArray(action.payload) ? action.payload : [],
      };
    case "SET_META_INTERNAL_LINKS":
      return {
        ...state,
        internalLinks: Array.isArray(action.payload) ? action.payload : [],
      };
    default:
      return state;
  }
};
